import React from 'react';
import { bonuses } from '../data/bonuses';
import { BONUS_VALUE } from '../data/offer';
export function Bonuses() {
  const [featured, ...rest] = bonuses;
  return <section aria-labelledby="bonuses-heading" className="w-full bg-cream" data-id="element-30" data-mp="plsj010puu7n">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-31" data-mp="autf33atstue">
        <p className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-terracotta-soft text-terracotta text-[11px] sm:text-xs font-semibold uppercase tracking-[0.12em]" data-id="element-32" data-mp="ft4ppg8y38do">
          <span aria-hidden="true" data-id="element-33" data-mp="5wi60uscund8">🎁</span>
          Five bonuses included free
        </p>

        <h2 id="bonuses-heading" className="mt-5 font-serif font-bold text-ink text-2xl sm:text-4xl" data-id="element-34" data-mp="3o1v84n1sa6su">
          Total value: {BONUS_VALUE} → free with Homeschool, Handled.
        </h2>

        <div className="mt-10 rounded-2xl bg-white border border-cream-dark shadow-card overflow-hidden" data-id="element-35" data-mp="1m9ywldfm8wy2">
          <div className="grid md:grid-cols-[minmax(0,15rem)_1fr]" data-id="element-36" data-mp="1r8a43hifuvd4">
            <img src={featured.cover} alt={`Cover of ${featured.title}`} className="w-full h-56 md:h-full object-cover" width={1024} height={1024} loading="lazy" data-id="element-37" data-mp="3ie6gre1r3vu3" />
            <div className="p-6 sm:p-8" data-id="element-38" data-mp="3r5ylr980acra">
              <div className="flex items-baseline justify-between gap-4" data-id="element-39" data-mp="3n5eswhugtvay">
                <span className="font-serif font-bold text-sm text-sage tracking-[0.14em] uppercase" data-id="element-40" data-mp="3n7iswop8ua5y">
                  Bonus {featured.number}
                </span>
                <span className="text-sm font-semibold text-ink-muted whitespace-nowrap" data-id="element-41" data-mp="2ui24010u1beh">
                  <span className="line-through" data-id="element-42" data-mp="38h1tfaw65ubp">{featured.price}</span>{' '}
                  <span className="text-vital" data-id="element-43" data-mp="33gw80cght422">→ Free</span>
                </span>
              </div>
              <h3 className="mt-3 font-serif font-bold text-xl sm:text-2xl text-ink leading-snug" data-id="element-44" data-mp="np8e6pwrzrnh">
                {featured.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-45" data-mp="it13kjtfprz7">
                {featured.body}
              </p>
            </div>
          </div>
        </div>

        <ul className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-46" data-mp="3hgoltrh1njr1">
          {rest.map(bonus => <li key={bonus.number} className="flex flex-col rounded-2xl bg-white border border-cream-dark shadow-card overflow-hidden" data-id="element-47" data-mp="3lk4bg3up4ju8">
              <img src={bonus.cover} alt={`Cover of ${bonus.title}`} className="w-full aspect-[4/3] object-cover object-center" width={1024} height={1024} loading="lazy" data-id="element-48" data-mp="2ttgel40220md" />

              <div className="flex flex-col flex-grow p-6 sm:p-7" data-id="element-49" data-mp="37kd60ri8wbru">
                <div className="flex items-baseline justify-between gap-4" data-id="element-50" data-mp="37lo9srboxjiy">
                  <span className="font-serif font-bold text-sm text-sage tracking-[0.14em] uppercase" data-id="element-51" data-mp="2a45zns84vjpb">
                    Bonus {bonus.number}
                  </span>
                  <span className="text-sm font-semibold text-ink-muted whitespace-nowrap" data-id="element-52" data-mp="27iyk9eyld4qi">
                    <span className="line-through" data-id="element-53" data-mp="22kn5qqxcq61y">{bonus.price}</span>{' '}
                    <span className="text-vital" data-id="element-54" data-mp="1xlk3fe8radxo">→ Free</span>
                  </span>
                </div>

                <h3 className="mt-3 font-serif font-bold text-xl text-ink leading-snug" data-id="element-55" data-mp="1tkrukm3sqb1x">
                  {bonus.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-56" data-mp="1omqdg6pxklt3">
                  {bonus.body}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}